const braintree = require('braintree-web');
const $ = require('jquery');

class PaypalService {
    constructor(restangular, $q, $window) {
        this._q = $q;
        this._window = $window;
        this._api = restangular.one('Paypal');
        this.integration = null;
        this.deviceData = null;
        this.callBack = null;
    }

    setup(paypal, callBack) {
        const self = this;
        const deferred = this._q.defer();
        this.token = null;
        this.nonce = null;
        this.deviceData = null;
        this.customerEmail = null;
        this.integration = null;

        const options = $.extend({
            singleUse: false,
            displayName: 'WoolWorths',
            enableShippingAddress: false,
            enableBillingAddress: false,
            headless: true,
        }, paypal);

        this._api.post('Token')
            .then((response) => {
                braintree.setup(response.ClientToken, 'custom', {
                    dataCollector: {
                        paypal: true,
                    },
                    onReady(integration) {
                        self.integration = integration;
                        self.deviceData = integration.deviceData;
                        deferred.resolve({ hasError: false });
                    },
                    onError(type, message) {
                        deferred.reject({ hasError: true, type, message });
                    },
                    onPaymentMethodReceived(payload) {
                        // retrieve nonce from payload.nonce
                        if (callBack != null) {
                            callBack(payload);
                        }
                    },
                    paypal: options,
                });
            });

        return deferred.promise;
    }

    initAuthFlow() {
        this.integration.paypal.initAuthFlow();
    }

    getCurrentCustomer() {
        return this._api.post('Customer');
    }

    getDeviceData() {
        return this.deviceData;
    }

    removeAccount() {
        const self = this;
        return this._api.post('Remove').then(() => {
            self.token = null;
            self.nonce = null;
        });
    }

    isReady() {
        return this.integration !== null && this.integration !== undefined;
    }

    isTokenized() {
        return this.token !== null && this.token !== undefined;
    }

    linkAccount(nonce, email, deviceData) {
        const self = this;

        return this._api.post('Link', { Nonce: nonce, Email: email, DeviceData: deviceData }).then((payload) => {
            self.token = payload.Token;
            self.customerEmail = email;

            return payload;
        });
    }

    resolveAddress(details) {
        if (details.shippingAddress !== undefined && details.shippingAddress !== null) {
            return details.shippingAddress;
        }

        if (details.billingAddress !== undefined && details.billingAddress !== null) {
            return details.billingAddress;
        }

        return null;
    }
}

module.exports = PaypalService;



// WEBPACK FOOTER //
// ./src/common/paypal/paypal.service.js